<!-- 产品-设备重复详情 -->
<template>
  <div class="md-layout">
    <!-- 卡片-设备重复详情表格 -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 卡片-主体-查询表单 -->
          <div class="md-layout card-form" style="max-width: 700px;">
              <!-- 表单-选择栏-数据类型 {uid: UID, mac: MAC} -->
              <div class="md-layout-item md-size-25 left-layout-item md-xsmall-size-50">
                <md-field>
                  <md-select v-model="searchForm.searchType" >
                    <md-option value="uid">{{$I18n('search_by_uid')}}</md-option>
                    <md-option value="mac">{{$I18n('search_by_mac')}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- 表单-输入栏-查询参数 (和上面的选择相绑定) -->
              <div class="md-layout-item md-size-25 left-layout-item md-xsmall-size-50">
                <md-field>
                  <label v-if="searchForm.searchType === 'uid'">UID</label>
                  <label v-if="searchForm.searchType === 'mac'">MAC</label>
                  <md-input v-model="searchForm.searchValue"/>
                </md-field>
              </div>
              <!-- 表单-选择栏-状态 {0: 全部, 1: 待处理, 2: 处理中} -->
              <div class="md-layout-item md-size-25 left-layout-item md-xsmall-size-50">
                <md-field>
                  <label>{{$I18n("state")}}</label>
                  <md-select v-model="searchForm.state" >
                    <md-option value="0">{{$I18n('all')}}</md-option>
                    <md-option value="1">{{$I18n('pending')}}</md-option>
                    <md-option value="2">{{$I18n('processed')}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- 表单-按钮 (只在小屏幕模式下显示) -->
              <div class="md-layout-item md-size-25">
                <md-button class= "left-icon md-info" @click="form_changeSearchData">
                  <md-icon>search</md-icon>{{$I18n("search")}}
                </md-button>
              </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 卡片-主体-表格
            体系
            所属企业
            UID
            MAC
            IP
            所属区域
            状态 {1:待处理, 2:已处理}
            更新时间
            创建时间
            操作 {修改该设备}
           -->
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('ser_sys')">{{ item.sys }}</md-table-cell>
              <md-table-cell :md-label="$I18n('company')">{{ item.company }}</md-table-cell>
              <md-table-cell :md-label="'UID'">{{ item.uid }}</md-table-cell>
              <md-table-cell :md-label="'MAC'">{{ item.mac }}</md-table-cell>
              <md-table-cell :md-label="'IP'">{{ item.ip }}</md-table-cell>
              <md-table-cell :md-label="$I18n('zone')">{{ item.zone_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('state')">{{ item.dev_state }}</md-table-cell>
              <md-table-cell :md-label="$I18n('update_date')">{{ item.update_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('created_thing_time')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button @click.stop @click="table_edit(item)" class="md-just-icon md-round md-info left-icon">
                  <md-icon>edit</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal ref="modal" :title="modalTitle" :right="true" @submit="modal_submit">
      <!-- 弹窗-主体 -->
      <template slot="body">
        <div class="md-layout">
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error ="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass } from "@/common/tools.js";
export default {
  data() {
    return {
      modalSearchData : { // 弹窗-查询表单
        state : 0,
        time : [],
      },
      searchForm : { // 表单-筛选表格的查询表单
        searchType : "uid",
        searchValue: "",
        state : "0",
      },
      searchData : { // API-筛选表格的查询数据
        mac : "",
        uid : "",
        state: 0,
      },
      // 表格相关
      icon  : "computer",
      title : this.$I18n("devdup"),
      tableInitData : [], // 表格数据
      compData : [], // 公司数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
      // 弹窗相关
      modalTitle : this.$I18n("devdup"),  // 弹窗标题
      // 弹窗表单相关
      modalData : new FormClass({
        id : "",
        state : "",
      }),
    };
  },
  mounted : function() {
    this.api_getComp();
    this.api_getPageData();
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage() {
      this.api_getPageData();
    },
  },
  methods: {
    table_edit(item){ // 桌面-修改该数据
      this.$refs.modal.open();
      this.modalData.Update(item)
    },
    api_getPageData(){ // API-获取页面信息
      // 获取角色
      let page_no = this.currentPage;
      this.$api.getDevDup({ // api: /iot/uid/duplicate/get
          ...this.searchData,
          page_size: this.pageSize,
          page_no: this.currentPage,
      })
        .then(this.$Then(res => {
          if (page_no !== this.currentPage) {
            return;
          }
          this.total = res.count;
          this.tableInitData = res.data.map(item => {
            return {
              ...item,
              ver: item.ver ?item.ver :"",
            };
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.total = 0;
          this.tableInitData = [];
        }))
    },
    // 获取公司信息
    api_getComp (){
      //获取菜单
      this.$api.getCompanyList({}) // api: /user/company/query
        .then(this.$Then(res => {
          this.compData = res.data;
        }))
        .catch(this.$Catch("", () => {
          this.compData = [];
        }))
    },
    // 更改查询条件(并立刻查询)
    form_changeSearchData () {
      this.currentPage = 1;
      this.searchData = {
        mac : this.searchForm.searchType === "mac" ?this.searchForm.searchValue :"",
        uid : this.searchForm.searchType === "uid" ?this.searchForm.searchValue :"",
        state: parseInt(this.searchForm.state),
      };
      this.api_getPageData();
    },
    // 提交表单
    modal_submit () {
      this.$api.setDevDup({ // api: /iot/uid/duplicate/set
          id:    this.modalData.Form.id,
          state: this.modalData.Form.state,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"));
          this.api_getPageData();
          this.$refs.modal.close();
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
  },
  computed: {
    modalTableForm(){ // 弹窗-表格查询表单
      return {
        state            : this.modalSearchData.state,
        import_start_time: this.modalSearchData.time[0]?this.modalSearchData.time[0] :"",
        import_end_time  : this.modalSearchData.time[1]?this.modalSearchData.time[1] :"",
      }
    },
    modalTableData () { // 弹窗-表格展示用数据(处理后)
      if (!this.modalTableInitData || this.modalTableInitData.length === 0){
        return [];
      } else {
        return [...this.modalTableInitData]
          .splice((this.currentPage-1) * this.pageSize, this.pageSize)
          .map(item => {
            // 公司
            let company  = this.$I18n("unknow");
            this.compData.forEach(function(com){
                if(com.comp_id == item.comp_id){
                  company = com.comp_short_name ?com.comp_short_name :com.comp_name;
                }
            })
            // 导入状态
            let import_state = this.$I18n("unknow");
            if(item.state== 1){
              import_state = this.$I18n("has_sync_database");
            }else if(item.state == 4){
              import_state = this.$I18n("wait_sync_database");
            }else if(item.state == 2 ){
              import_state = this.$I18n("has_error_row");
            } else if( item.state == 3){
              import_state = this.$I18n("file_error");
            }
            // 数字
            item.mng_num =  isNaN(item.mng_num )  ?0 :item.mng_num ;
            item.succ_num = isNaN(item.succ_num ) ?0 :item.succ_num;
            item.fail_num = isNaN(item.fail_num ) ?0 :item.fail_num;
            return {
              company,
              import_state,
              ... item,
            }
          })
      }
    },
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(item => {
          // 公司
          let company  = this.$I18n("unknow");
          this.compData.forEach(function(com){
              if(com.comp_id == item.comp_id){
                company = com.comp_short_name ?com.comp_short_name :com.comp_name;
              }
          })
          // 状态
          let dev_state = "";//this.$I18n('unknown')
          switch(item.state){
            case "1":
            case 1:
              dev_state = this.$I18n("pending");
              break;
            case "2":
            case 2:
            default:
              dev_state = this.$I18n("processed");
              break;
          }
          // 区域名称
          let zone_name = this.$I18n("unknow");
          if (item.zone){
            zone_name = this.$I18n(item.zone);
          }
          // 源区域名称
          let src_zone_name = this.$I18n("unknow");
          if (item.src_zone){
            src_zone_name = this.$I18n(item.src_zone);
          }

          return {
            dev_state,
            company,
            zone_name,
            src_zone_name,
            ... item,
          }
        })
      }
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("ser_sys"),
          keys    : "sys",
          type    : "input",
          disabled: true,
          class: "md-layout-item md-size-50",
        },{
          label   : this.$I18n("company"),
          keys    : "company",
          type    : "input",
          disabled: true,
          class: "md-layout-item md-size-50",
        },{
          label   : "UID",
          keys    : "uid",
          type    : "input",
          disabled: true,
          class: "md-layout-item md-size-100",
        },{
          label   : "MAC",
          keys    : "mac",
          type    : "input",
          disabled: true,
          class: "md-layout-item md-size-50",
        },{
          label   : this.$I18n("src_mac"),
          keys    : "src_mac",
          type    : "input",
          disabled: true,
          class: "md-layout-item md-size-50",
        },{
          label   : "IP",
          keys    : "ip",
          type    : "input",
          disabled: true,
          class: "md-layout-item md-size-50",
        },{
          label   : this.$I18n("src_ip"),
          keys    : "src_ip",
          type    : "input",
          disabled: true,
          class: "md-layout-item md-size-50",
        },{
          label   : this.$I18n("zone"),
          keys    : "zone_name",
          type    : "input",
          disabled: true,
          class: "md-layout-item md-size-50",
        },{
          label   : this.$I18n("src_zone"),
          keys    : "src_zone_name",
          type    : "input",
          disabled: true,
          class: "md-layout-item md-size-50",
        },{
          label   : this.$I18n("state"),
          keys    : "state",
          type    : "select",
          options : [
            {
              id  : 1,
              name: this.$I18n("pending"),
            },{
              id  : 2,
              name: this.$I18n("processed"),
            }
          ],
          disabled: true,
          class: "md-layout-item md-size-100",
        },{
          label   : this.$I18n("update_date"),
          keys    : "update_time",
          type    : "input",
          disabled: true,
          class: "md-layout-item md-size-50",
        },{
          label   : this.$I18n("created_thing_time"),
          keys    : "create_time",
          type    : "input",
          disabled: true,
          class: "md-layout-item md-size-50",
        }
      ];
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 60px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }
</style>
